<template>
    <autocomplete type="text"
        v-if="clicked"
        @blur="clicked = false;"
        @keydown.enter="clicked = false;"
        v-focus=""
        :search="search"
        placeholder="Search for a Member"
        aria-label="Search for a Member"
        :get-result-value="getResultValue"
        @submit="handleSubmit"
    /></autocomplete>
        <button v-else="" class="text-xxs align-middle py-0 pl-2 pr-0" @click="clicked = true;">
          {{labelLocal}} <i aria-hidden="true" class="material-icons align-middle text-3xl ml-1">add_box</i>
        </button>
</template>

<script>
export default {

  props: ['label'],

  data () {
  return {
      clicked: false,
      labelLocal: this.label
    }
  },

  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }

}

</script>
